















































































import { Component, Watch } from 'vue-property-decorator';
import { AuthModule } from '@/store/Auth/AuthModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import PermissionUtils from '@/lib/permissionUtils';
import PortalUIMode from '@/models/Shared/PortalUIMode';
import { version } from '../../../../package.json';

@Component({ name: 'PortalSettings' })
export default class extends SaascadaVue {

    dialog: boolean = false;
    PermissionUtils = PermissionUtils;
    PortalUIMode = PortalUIMode;
    // Initialise settings based on the previously saved user preferences
    numberOfRows: number = localStorage.getItem("saascada-number-of-rows") ? parseInt(localStorage.getItem("saascada-number-of-rows")) : 10;
    selectedMode: string = localStorage.getItem("saascada-display-mode") ? localStorage.getItem("saascada-display-mode") : PortalUIMode.LightMode;
    enableUxApiAccessToggle: boolean = localStorage.getItem("saascada-disable-ux-api-access") ? false : true;

    get institutionName() {
        return AuthModule.me.institution.name;
    }

    get portalVersion() {
        var packageVersion = version;
        return `v${packageVersion}`;
    }

    get portalCopyright() {
        var year = new Date().getFullYear();
        return `© SaaScada ${year}`;
    }

    get numberOfRowsOptions() {
        return [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30];
    }

    @Watch('numberOfRows')
    async onNumberOfRowsChanged(rows: number) {
        localStorage.setItem("saascada-number-of-rows", rows.toString());
    }

    @Watch('selectedMode')
    async onSelectedModeChanged(selectedMode: string) {
        if (selectedMode === PortalUIMode.LightMode) {
            this.$vuetify.theme.dark = false;
            localStorage.setItem("saascada-display-mode", PortalUIMode.LightMode);
        }
        if (selectedMode === PortalUIMode.DarkMode) {
            this.$vuetify.theme.dark = true;
            localStorage.setItem("saascada-display-mode", PortalUIMode.DarkMode);
        }
        if (selectedMode === PortalUIMode.MatchBrowser) {
            this.$vuetify.theme.dark = true;
            localStorage.setItem("saascada-display-mode", PortalUIMode.MatchBrowser);
        }
    }

    @Watch('enableUxApiAccessToggle')
    async onEnableUxApiAccessToggleChanged(isEnabled: boolean) {
        if (isEnabled) {
            localStorage.removeItem("saascada-disable-ux-api-access");
        }
        else {
            localStorage.setItem("saascada-disable-ux-api-access", "YES");
        }
    }

    close() {
        this.dialog = false;
    }

};
